import React from "react";
import Moment from "react-moment";

import UserService from "services/user";

import ZeeTable from "components/ZeeTable";

export default class extends React.Component {
  userService = new UserService();

  state = {
    data: null,
  };

  columns = {
    name: { name: "Name" },
    email: { name: "Email Address" },
  };

  constructor() {
    super(...arguments);

    this.userService.getAll().then(({ data }) => this.setState(data));
  }

  async onDelete(user) {
    const result = await this.userService.delete(user).then(({ data }) => data);
    if (result.success) {
      return result.data;
    }
    return false;
  }

  async onEdit(user) {
    const result = await this.userService.update(user).then(({ data }) => data);
    if (result.success) {
      return result.data;
    }
    return false;
  }

  async onAdd(user) {
    const result = await this.userService.create(user).then(({ data }) => data);
    if (result.success) {
      return result.data;
    }
    return false;
  }

  render() {
    const { data } = this.state;

    const hasDataLoaded = data ? true : false;
    if (hasDataLoaded) {
      return (
        <ZeeTable
          title="Users"
          columns={this.columns}
          data={data}
          hasPagination={true}
          hasSort={true}
          hasSelection={true}
          hasDelete={true}
          hasEdit={true}
          hasAdd={true}
          hasSearch={true}
          orderBy="name"
          //onSelect={onSelect}
          onEdit={(user) => this.onEdit(user)}
          onDelete={(user) => this.onDelete(user)}
          onAdd={(user) => this.onAdd(user)}
          //onSelectionConfirm={onSelectionConfirm}
        />
      );
    }

    return <p>Loading data</p>;
  }
}
